import getSubdomain from "../services/utils/utiltyFunctions";

// Sandbox mode: the real app running against an in-browser simulator instead
// of the backend. Active only on the `sandbox` subdomain (or
// localhost/?subdomain=sandbox in development). Nothing in this mode reaches
// the server: fetch calls to /api are answered locally and the socket is a
// local object.

export type SandboxRole = "user" | "admin";

const ROLE_KEY = "sandbox_role";
export const SANDBOX_ORG_ID = 1;
export const SANDBOX_SUBDOMAIN = "sandbox";

export function isSandbox(): boolean {
  try {
    return getSubdomain() === SANDBOX_SUBDOMAIN;
  } catch (_) {
    return false;
  }
}

export interface SandboxUser {
  sub: string;
  username: string;
  fullname: string;
  phonenumber: string;
  organizationid: number;
  role: string;
  created_at: string;
  disabled_at: string | null;
}

export function sandboxUser(role: SandboxRole): SandboxUser {
  return {
    sub: role === "admin" ? "sandbox-admin" : "sandbox-tech",
    username: role === "admin" ? "admin@sandbox.example" : "tech@sandbox.example",
    fullname: role === "admin" ? "Sandbox Admin" : "Sandbox Tech",
    phonenumber: "+15555550100",
    organizationid: SANDBOX_ORG_ID,
    role,
    created_at: new Date(Date.now() - 90 * 86400000).toISOString(),
    disabled_at: null,
  };
}

export function getRole(): SandboxRole | null {
  try {
    const r = sessionStorage.getItem(ROLE_KEY);
    return r === "admin" || r === "user" ? r : null;
  } catch (_) {
    return null;
  }
}

// AuthContext restores a session on reload only when a `token` cookie holds
// the expiry (unix seconds). The sandbox sets one far enough out that the
// session-expiry dialog never appears during a visit.
export function enterSandbox(role: SandboxRole) {
  try {
    sessionStorage.setItem(ROLE_KEY, role);
  } catch (_) {}
  const exp = Math.floor(Date.now() / 1000) + 12 * 3600;
  document.cookie = `token=${exp}; path=/; SameSite=Strict`;
}

export function exitSandbox() {
  try {
    sessionStorage.removeItem(ROLE_KEY);
  } catch (_) {}
  document.cookie = "token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
}
